import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { trackLinkClick } from '../analytics';
import { allow } from '../classes/allow';
import local from '../classes/local';
import translate from '../functions/translate';
import medicareLogo from '../images/medicare-logo-green.svg';
import the from '../objects/the';
import './css/custom.css';
import HorizontalBar from './horizontal.bar';
import MDAndLargerDiv from './md.and.larger.div';
import TranslatedSpan from './translated.span';
import XSAndSMDiv from './xs.and.sm.div';
import { getChatUrl } from '../functions/get.chat.url';
import getEnvironment from '../functions/get.environment';


export default function SiteHeader() {
   const [hamburgerMenuIsOpen, setHamburgerMenuIsOpen] = useState(false);
   const location = useLocation();
   const history = useHistory();
   
   const getHamburgerMenu = () => {
      const icon = hamburgerMenuIsOpen ? the.icon.x : the.icon.hamburgerMenu;
      const title = hamburgerMenuIsOpen ? translate('Close the Resources Menu') : translate('Resources');
      return <>
         <div style={{
            alignItems: 'center',
            display: 'flex',
            height: '100%',
         }}>
            <button
               aria-expanded={hamburgerMenuIsOpen ? 'true' : 'false'}
               onClick={toggleHamburgerMenuIsOpen}
               style={styleFreeButtonCSS}
               title={title}
               type={'button'}
            >
               <span className={'ds-u-visibility--screen-reader'}>{translate('Resources')}</span>
               <FontAwesomeIcon
                  icon={icon}
                  style={{
                     color: the.color.forestGreen,
                     cursor: 'pointer',
                     fontSize: '1.5em',
                  }}
               />
            </button>
         </div>
      </>
   };
   
   const getLanguageLink = (isInAVerticalList = false) => {
      allow.aBoolean(isInAVerticalList);
      return <>
         <li style={{listStyleType: 'none'}}>
            <button
               id={'languageButton'}
               onClick={goToLanguage}
               style={styleFreeButtonCSS}
               title={language === 'English' ? 'Ver en Español' : 'See in English'}
               type={'button'}
            >
               <div
                  className={'toggleGreenWhite'}
                  style={{
                     paddingBottom: isInAVerticalList ? 15 : 0,
                     paddingLeft: 15,
                     paddingRight: 15,
                     paddingTop: isInAVerticalList ? 15 : 0,
                  }}
               >
                  {language === 'English' ? 'Español' : 'English'}
               </div>
            </button>
         </li>
      </>
   };
   
   const getLiveChatLink = (isInAVerticalList = false) => {
      allow.aBoolean(isInAVerticalList);
      return <>
         <li style={{listStyleType: 'none'}}>
            <button
               id={'liveChatButton'}
               onClick={openLiveHelp}
               style={styleFreeButtonCSS}
               title={`${translate('Live Chat')} - ${translate('Opens in a new window')}`}
               type={'button'}
            >
               <div
                  className={'toggleGreenWhite'}
                  style={{
                     paddingBottom: isInAVerticalList ? 15 : 0,
                     paddingLeft: 15,
                     paddingRight: 15,
                     paddingTop: isInAVerticalList ? 15 : 0,
                  }}
               >
                  <FontAwesomeIcon
                     icon={the.icon.chatBubbles}
                     style={{marginRight: 5}}
                  />
                  <strong><TranslatedSpan english={'Live Chat'}/></strong>
               </div>
            </button>
         </li>
      </>
   };
   
   const getLoginLink = (isInAVerticalList = false) => {
      allow.aBoolean(isInAVerticalList);
      if (location.pathname.startsWith('/login'))
         return null;
      return <>
         <li style={{listStyleType: 'none'}}>
            <Link
               style={{textDecoration: 'none'}}
               title={translate('Log in')}
               to={'/login'}
            >
               <div
                  className={'toggleGreenWhite'}
                  style={{
                     paddingBottom: isInAVerticalList ? 15 : 0,
                     paddingLeft: 15,
                     paddingRight: 15,
                     paddingTop: isInAVerticalList ? 15 : 0,
                  }}
               >
                  <TranslatedSpan english={'Log in'}/>
               </div>
            </Link>
         </li>
      </>
   };
   
   const getResourcesMenu = () => {
      if (!hamburgerMenuIsOpen)
         return null;
      return <>
         <nav aria-label={translate('Header')}>
            <ul style={{paddingLeft: 0}}>
               {getLiveChatLink(the.isInAVerticalList)}
               {getLoginLink(the.isInAVerticalList)}
               {getLanguageLink(the.isInAVerticalList)}
            </ul>
         </nav>
      </>;
   };
   
   const goToLanguage = () => {
      let languageLink = location.pathname;
      languageLink += language === 'English' ? '?Lang=es-mx' : '?Lang=en-us';
      history.push(languageLink);
      document.getElementById('languageButton').blur();
   };
   
   const openLiveHelp = () => {
      const isImp = getEnvironment() === 'implementation';
      const chatUrlPrefix = '/mbp';
      let chatUrl = getChatUrl();
      if (isImp) {
         chatUrl = `${chatUrlPrefix}/webchat/CMS-MBP_Webchat.aspx`;
      }
      
      const liveHelp = window.open(chatUrl, 'LiveChat', 'height=730,width=680,scrollbars=1');
      liveHelp.moveTo(50, 100);
      document.getElementById('liveChatButton').blur();
      return false;
   };
   
   const styleFreeButtonCSS = {
      backgroundColor: 'white',
      border: 0,
      fontFamily: 'inherit',
      fontSize: '100%',
      height: '100%',
      padding: 0,
      width: '100%',
   };
   
   const toggleHamburgerMenuIsOpen = () => setHamburgerMenuIsOpen(!hamburgerMenuIsOpen);
   
   const language = local.getItem('language', 'English');
   return <>
      <header style={{height: 66}}>
         <div style={{
            alignItems: 'stretch',
            display: 'flex',
            height: '100%',
            paddingRight: 15,
         }}>
            <div style={{
               paddingTop: 20,
               marginLeft: 30,
               width: 200,
            }}>
               <a
                  href={language === 'English' ? 'http://www.medicare.gov' : 'http://es.medicare.gov'}
                  id={'headerlogo-link'}
                  style={{textDecoration: 'none'}}
                  title={translate('Medicare.gov - the Official U.S. Government Site for Medicare')}
                  onClick={trackLinkClick}
               >
                  <img
                     alt={translate('Medicare.gov - the Official U.S. Government Site for Medicare')}
                     src={medicareLogo}
                     style={{
                        height: 33,
                        width: 200,
                     }}
                  />
               </a>
            </div>
            <div style={{flexGrow: 1}}></div>
            <MDAndLargerDiv style={{display: 'flex'}}>
               {getLiveChatLink()}
               {getLoginLink()}
               {getLanguageLink()}
            </MDAndLargerDiv>
            <XSAndSMDiv style={{display: 'flex'}}>
               {getHamburgerMenu()}
            </XSAndSMDiv>
         </div>
      </header>
      {getResourcesMenu()}
      <HorizontalBar/>
   </>;
}